import { render, staticRenderFns } from "./ClothSelectModal.vue?vue&type=template&id=48cadb88&scoped=true"
import script from "./ClothSelectModal.vue?vue&type=script&lang=js"
export * from "./ClothSelectModal.vue?vue&type=script&lang=js"
import style0 from "./ClothSelectModal.vue?vue&type=style&index=0&id=48cadb88&prod&lang=scss&scoped=true"
import style1 from "./ClothSelectModal.vue?vue&type=style&index=1&id=48cadb88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cadb88",
  null
  
)

export default component.exports